import { createApp } from 'vue';
import Wishlist from './wishlist.vue';
import commonStore from '../global/common-store';
import focusTrap from '../../utils/focus-trap';

export default () => {
  createApp(Wishlist).directive('focus-trap', focusTrap).use(commonStore).mount("vue-wishlist");
}